import { X, AlertTriangle, Ban, Trash2, RotateCcw } from "lucide-react";
import moment from "moment-jalaali";

// تابع کمکی برای تبدیل تاریخ میلادی به شمسی
const formatShamsiDate = (dateStr) => {
  if (!dateStr) return "";
  return moment(dateStr, "YYYY-MM-DD").format("jYYYY/jMM/jDD");
};

const DeleteOrCancelModal = ({ show, onClose, onDelete, onCancel, appointment }) => {
  if (!show) return null;

  const isCancelled = appointment?.status === "لغو شده";

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 z-[1100] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in duration-200"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white w-full max-w-md rounded-2xl shadow-2xl overflow-hidden transform transition-all duration-300 scale-100"
      >
        {/* Header */}
        <div className="bg-gradient-to-r from-rose-500 to-rose-600 px-5 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center">
              <AlertTriangle className="w-5 h-5 text-white" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-white">عملیات روی قرار</h2>
              <p className="text-rose-100 text-xs mt-0.5">انتخاب کنید</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-lg bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
            aria-label="بستن"
          >
            <X className="w-4 h-4 text-white" />
          </button>
        </div>

        {/* Content */}
        <div className="p-5">
          <div className="bg-gray-50 rounded-xl p-4 mb-4 border border-gray-100">
            <p className="text-sm text-gray-600 leading-relaxed">
              شما در حال انجام عملیات روی قرار زیر هستید:
            </p>
            <div className="mt-2 font-medium text-gray-900 text-sm">
              {appointment?.user?.name} • {appointment?.service?.name} •{" "}
              {formatShamsiDate(appointment?.datetime?.date)} ساعت{" "}
              {appointment?.datetime?.time}
            </div>

            {/* وضعیت فعلی قرار */}
            <div className="mt-3 flex items-center gap-2">
              <span className="text-xs text-gray-500">وضعیت فعلی:</span>
              <span
                className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${
                  isCancelled
                    ? "bg-red-100 text-red-700"
                    : "bg-emerald-100 text-emerald-700"
                }`}
              >
                {appointment?.status}
              </span>
            </div>
          </div>

          <div className="space-y-3">
            {/* دکمه لغو یا بازگردانی */}
            <button
              onClick={onCancel}
              className={`w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl text-sm font-medium transition-colors ${
                isCancelled
                  ? "text-emerald-700 bg-emerald-50 border border-emerald-200 hover:bg-emerald-100"
                  : "text-amber-700 bg-amber-50 border border-amber-200 hover:bg-amber-100"
              }`}
            >
              {isCancelled ? (
                <>
                  <RotateCcw className="w-5 h-5" />
                  بازگردانی قرار
                </>
              ) : (
                <>
                  <Ban className="w-5 h-5" />
                  لغو قرار
                </>
              )}
            </button>

            {/* دکمه حذف کامل */}
            <button
              onClick={onDelete}
              className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl text-sm font-medium text-red-700 bg-red-50 border border-red-200 hover:bg-red-100 transition-colors"
            >
              <Trash2 className="w-5 h-5" />
              حذف کامل قرار
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteOrCancelModal;